"use client";
import Image from "next/image";
import React, { useRef, useState } from "react";
import WrapImgLeft from "../assets/svg/VideoWrapImgLeft";
import WrapImgRight from "../assets/svg/VideoWrapImgRight";
import { useDictionary } from "../context/dictionaryProvider";

const VideoPlayer = ({
  src,
  poster,
  playPosition = "left",
  classNames,
  videoSize,
}) => {
  const playerRef = useRef(null); // Reference to the video element
  const [start, setStart] = useState(false); // Play/pause state
  const dict = useDictionary();

  const handlePlay = () => {
    if (start) {
      playerRef.current.pause(); // Pause the video
    } else {
      playerRef.current.play(); // Play the video
    }
    setStart(!start); // Toggle play/pause state
  };

  return (
    <>
      {/* Video Player */}
      <video
        ref={playerRef} // Attach ref to the video element
        muted
        loop
        playsInline
        preload="none"
        poster={
          poster ||
          "https://d3v381xb6gm5e.cloudfront.net/media/13969942_de24873a03.png"
        }
        className={`w-full object-cover rounded-[16px] overflow-hidden videoDiv ${
          videoSize ? videoSize : "h-full"
        }`}
        title="Intro"
        src={src}
      />

      {/* Play/Pause Button */}
      <button onClick={handlePlay}>
        {playPosition === "right" && (
          <WrapImgRight src="../overwrapImg/vect1.png" />
        )}

        <Image
          className={`videoIcon ${
            dict?.dir === "rtl" ? "left-0 !right-auto" : "left-0 !right-1"
          }`}
          height={64}
          width={64}
          alt="play/pause"
          src={
            start
              ? "/pause.png"
              : "/play.png"
          }
          unoptimized
        />
        {playPosition === "left" && <WrapImgLeft />}
      </button>
    </>
  );
};

export default VideoPlayer;
